import hoverintent from 'hoverintent';
import { initiateFadeInUpAnimation, removeFadeInUpAnimation } from './fadeInUpAnimation';

export default class Menu {
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;
    this.activeClass = 'nav-hover';
    this.sectionId = this.element.getAttribute('data-wetheme-section-id');
    this.megaMenuDropdowns = document.querySelectorAll('.site-nav__dropdown.mega-menu-dropdown');
    this.megaMenu = document.querySelector('.mega-menu-block');
    this.megaMenuChildren = document.querySelectorAll('.mega-menu-block .dropdown-submenu');
    this.resizeTimeout = null;

    this.nav = document.getElementById('AccessibleNav');
    this.allLinks = this.nav.querySelectorAll('a');
    this.topLevel = this.nav.querySelectorAll('li > a');
    this.parents = this.nav.querySelectorAll('.site-nav--has-dropdown');
    this.mainLinks = this.nav.querySelectorAll('.site-nav--has-dropdown.first-level-dropdown');
    this.subMenus = this.nav.querySelectorAll('.site-nav__dropdown');
    this.subMenuLinks = this.nav.querySelectorAll('.site-nav__dropdown a');

    this.parents.forEach((el) => {
      this.setDropdownOffset(el);
    });

    this.subMenus.forEach((el) => {
      this.initScrollHandler(el);
      el.addEventListener('mouseleave', () => this.hideDropdown(el));
      el.addEventListener('focusout', () => this.hideDropdown(el));

      // Add mouseover event to handle child dropdowns
      el.querySelectorAll('li').forEach((childEl) => {
        childEl.addEventListener('mouseover', (evt) => this.handleChildHover(evt, childEl));
      });
    });

    this.adjustMegaMenuPosition();

    window.addEventListener('resize', () => {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }

      this.resizeTimeout = setTimeout(() => {
        this.parents.forEach((el) => {
          this.setDropdownOffset(el);
          this.adjustMegaMenuPosition();
        });
      }, 300);
    });

    if (window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', (e) => {
        if (e.detail.sectionId === this.sectionId) {
          this.element.classList.add('section-selected');
        } else {
          this.element.classList.remove('section-selected');
        }
      });

      document.addEventListener('shopify:section:deselect', (e) => {
        if (e.detail.sectionId === this.sectionId) {
          this.element.classList.remove('section-selected');
        }
      });

      document.addEventListener('shopify:section:load', (e) => {
        if (e.detail.sectionId === this.sectionId) {
          this.adjustMegaMenuPosition();
        }
      });
    }

    this.parents.forEach((el) => {
      el.addEventListener('mouseover', (evt) => this.handleParentEvent(evt, el));
      el.addEventListener('touchstart', (evt) => this.handleParentEvent(evt, el));
      el.addEventListener('focusin', (evt) => this.handleParentEvent(evt, el));
    });

    this.parents.forEach((el) => {
      hoverintent(
        el,
        (evt) => {
          document.querySelectorAll(`.${this.activeClass}`).forEach((activeEl) => {
            if (!activeEl.contains(evt.target)) {
              activeEl.classList.remove(this.activeClass);
            }
          });
        },
        () => {
          // Avoid using hideDropdown() here.
        }
      );
    });

    this.mainLinks.forEach((el) => {
      el.addEventListener('mouseleave', () => this.hideDropdown());
    });

    document.querySelector('.site-header').addEventListener('mouseleave', () => {
      this.hideDropdown();
    });

    this.subMenus.forEach((el) => {
      el.addEventListener('mouseleave', () => this.hideDropdown(el));
      el.addEventListener('focusout', () => this.hideDropdown(el));
    });

    if (this.megaMenu) {
      this.megaMenu.addEventListener('mouseleave', () => this.hideDropdown());
    }

    this.subMenuLinks.forEach((link) => {
      link.addEventListener('touchstart', (evt) => {
        evt.stopImmediatePropagation();
      });
    });

    this.allLinks.forEach((link) => {
      link.addEventListener('focusin', (evt) => {
        const parentEl = link.parentElement;
        this.closeSiblings(parentEl, evt);
      });
    });

    document.querySelectorAll('.site-header a, .site-header button, .site-header select').forEach((el) => {
      el.addEventListener('focusin', () => {
        let closeAllMenus = true;
        this.allLinks.forEach((link) => {
          if (link === el) {
            closeAllMenus = false;
          }
        });

        if (closeAllMenus) {
          this.parents.forEach((parent) => {
            this.hideDropdown(parent);
          });
        }
      });
    });

    // Bind the event handler
    this.handleBodyTouchStart = this.handleBodyTouchStart.bind(this);
  }

  // Named event handler for touchstart
  handleBodyTouchStart(evt) {
    if (!evt.target.closest('.site-nav__link, .dropdown-submenu')) {
      this.hideDropdown();
    }
  }

  handleChildHover(evt, childEl) {
    // Close all sibling dropdowns
    const siblings = Array.from(childEl.parentElement.children).filter(sibling => sibling !== childEl);
    this.hideDropdown(siblings);

    // Show the current dropdown if it has one
    if (childEl.classList.contains('site-nav--has-dropdown')) {
      this.showDropdown(childEl);
    }
  }

  handleParentEvent(evt, el) {
    let ret = true;
    if (!el.classList.contains(this.activeClass)) {
      evt.preventDefault();
      const siblings = Array.from(el.parentElement.children).filter(sibling => sibling !== el);
      this.hideDropdown(siblings);
      ret = false;
    }
    this.showDropdown(el);
    return ret;
  }

  initScrollHandler(el) {
    let scrolling;
    el.addEventListener('scroll', () => {
      clearTimeout(scrolling);
      el.classList.add('scrolling');
      scrolling = setTimeout(() => {
        el.classList.remove('scrolling');
      }, 800);
    });
  }

  closeSiblings(el, evt) {
    if (!el.classList.contains(this.activeClass)) {
      evt.preventDefault();
      this.hideDropdown(Array.from(el.parentElement.children).filter(sibling => sibling !== el));
    }
  }

  adjustMegaMenuPosition() {
    this.megaMenuDropdowns.forEach((item) => {
      const menuItem = item.closest('.site-nav--has-dropdown');
      const menuItemRect = menuItem.getBoundingClientRect();
      item.style.left = `-${menuItemRect.left}px`;
    });
  }

  showDropdown(el) {
    if (!el) return;
    el.classList.add(this.activeClass);
    const megaMenuChildrenArray = Array.from(el.querySelectorAll('.mega-menu-block .dropdown-submenu'));
    initiateFadeInUpAnimation(megaMenuChildrenArray);

    document.querySelector('.sticky-header').classList.remove('sticky-header-transformed');

    setTimeout(() => {
      document.body.addEventListener('touchstart', this.handleBodyTouchStart);
    }, 250);
  }

  hideDropdown(elements) {
    if (elements) {
      // Ensure elements is an array or NodeList
      if (!Array.isArray(elements) && !(elements instanceof NodeList)) {
        elements = [elements]; // Convert single element to array
      }
  
      elements.forEach(el => {
        el.classList.remove(this.activeClass);
        const megaMenuChildrenArray = Array.from(el.querySelectorAll('.mega-menu-block .dropdown-submenu'));
        if (!this.element.classList.contains('section-selected') && !Array.from(this.parents).some(parent => parent.classList.contains('nav-hover'))) {
          removeFadeInUpAnimation(megaMenuChildrenArray);
        }
      });
    } else {
      document.querySelectorAll('.site-nav--has-dropdown').forEach((dropdown) => {
        dropdown.classList.remove(this.activeClass);
      });
  
      if (!this.element.classList.contains('section-selected') && !Array.from(this.parents).some(parent => parent.classList.contains('nav-hover'))) {
        removeFadeInUpAnimation(this.megaMenuChildren);
      }
    }
  
    document.body.removeEventListener('touchstart', this.handleBodyTouchStart);
  
    if (!document.querySelector('.nav-hover')) {
      const stickyHeader = document.querySelector('.sticky-header');
      if (stickyHeader) {
        stickyHeader.classList.add('sticky-header-transformed');
      }
    }
  }

  setDropdownOffset(el) {
    const dropdown = el.querySelector('.site-nav__dropdown.standard-dropdown');
    if (!dropdown) return;

    const navPosition = dropdown.getAttribute('data-logoPlacement');
    const subDropdown = dropdown.querySelector('.site-nav__subdropdown');

    const dropdownRight = window.innerWidth - (dropdown.getBoundingClientRect().left + dropdown.offsetWidth);

    if (dropdownRight < 15) {
      dropdown.style.right = '0';
      dropdown.style.left = 'auto';
    }

    if (!subDropdown) return;

    const subDropdownRight = window.innerWidth - (subDropdown.getBoundingClientRect().left + subDropdown.offsetWidth);

    if (subDropdownRight < 15) {
      if (navPosition === 'left' || navPosition === 'above') {
        subDropdown.style.left = 'auto';
        subDropdown.style.right = '100%';
      } else {
        subDropdown.style.left = '100%';
        subDropdown.style.right = 'auto';
      }
    }
  }
}
